import { render, staticRenderFns } from "./appLogRouteConfig.vue?vue&type=template&id=71f353ed&"
import script from "./appLogRouteConfig.vue?vue&type=script&lang=js&"
export * from "./appLogRouteConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports